export type Preset = {
	index: number;
	ww: number;
	wl: number;
	name: string;
	modality: string;
};
